import Marquee from "react-fast-marquee";

const WORDS = [
  "REFINED LEAD",
  "LEAD ALLOYS",
  "RECYCLING",
  "BHARUCH",
  "GPCB · MOEF",
  "SUSTAINABLE",
];

export const Ticker = () => (
  <section
    data-testid="marquee-band"
    className="border-y border-[var(--mx-line)] bg-transparent py-8"
  >
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-6xl font-black uppercase tracking-tight text-[var(--mx-ink)] md:text-8xl">
            {w}
          </span>
          <span className="mx-8 text-3xl text-[var(--mx-copper-soft)] md:mx-14 md:text-5xl">
            —
          </span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default Ticker;
